import { AttributeConfiguration } from 'dashboard/apps/DashboardLayoutEditor/ControlPanel/Panels/AttributeEditorTable';
import {
  GovernmentIdVerificationModuleAttribute,
  SelfieVerificationModuleAttribute,
} from 'dashboard/modules/ResourceVerification/model';

export const VERIFICATION_GOVERNMENT_ID_ATTRIBUTES: AttributeConfiguration<GovernmentIdVerificationModuleAttribute>[] =
  [
    {
      label: 'Photos',
      key: GovernmentIdVerificationModuleAttribute.Photos,
      display: true,
    },
    {
      label: 'ID',
      key: GovernmentIdVerificationModuleAttribute.Id,
      display: true,
    },
    {
      label: 'Full Name',
      key: GovernmentIdVerificationModuleAttribute.FullName,
      display: true,
    },
    {
      label: 'Birth Date',
      key: GovernmentIdVerificationModuleAttribute.BirthDate,
      display: true,
    },
    {
      label: 'Issuing Country',
      key: GovernmentIdVerificationModuleAttribute.IssuingCountry,
      display: true,
    },
    {
      label: 'Issue Date',
      key: GovernmentIdVerificationModuleAttribute.IssueDate,
      display: true,
    },
    {
      label: 'Expiration Date',
      key: GovernmentIdVerificationModuleAttribute.ExpirationDate,
      display: true,
    },
    {
      label: 'Capture Method (front)',
      key: GovernmentIdVerificationModuleAttribute.CaptureMethod,
      display: true,
    },
    {
      label: 'Capture Method (back)',
      key: GovernmentIdVerificationModuleAttribute.CaptureMethodBack,
      display: true,
    },
    {
      label: 'Address',
      key: GovernmentIdVerificationModuleAttribute.Address,
      display: true,
    },
    {
      label: 'Nationality',
      key: GovernmentIdVerificationModuleAttribute.Nationality,
      display: true,
    },
    {
      label: 'Checks',
      key: GovernmentIdVerificationModuleAttribute.Checks,
      display: true,
    },
  ];

export const VERIFICATION_SELFIE_ATTRIBUTES: AttributeConfiguration<SelfieVerificationModuleAttribute>[] =
  [
    {
      label: 'Photos',
      key: SelfieVerificationModuleAttribute.Photos,
      display: true,
    },
    {
      label: 'Capture Method',
      key: SelfieVerificationModuleAttribute.CaptureMethod,
      display: true,
    },
    {
      label: 'Checks',
      key: SelfieVerificationModuleAttribute.Checks,
      display: true,
    },
  ];
